/**
 * ═══════════════════════════════════════════════════════
 * ELISEE — AI Smart Search Engine
 * ═══════════════════════════════════════════════════════
 * Semantic search enhancement with fuzzy matching,
 * synonym resolution, and trending suggestions.
 */
(function() {
  'use strict';

  /* ══════════════════════════════
     Football Knowledge Base
     ══════════════════════════════ */
  var SYNONYMS = {
    /* ── Nicknames → Collection handles ── */
    'bianconeri': 'juventus', 'bianconera': 'juventus', 'vecchia signora': 'juventus', 'juve': 'juventus', 'jventus': 'juventus', 'jucentus': 'juventus', 'gobbi': 'juventus',
    'nerazzurri': 'inter', 'nerazzurra': 'inter', 'biscione': 'inter', 'inter milano': 'inter', 'internazionale': 'inter', 'intr': 'inter',
    'rossoneri': 'milan', 'rossonera': 'milan', 'diavolo': 'milan', 'ac milan': 'milan', 'acmilan': 'milan', 'miln': 'milan', 'mian': 'milan',
    'partenopei': 'napoli', 'azzurri napoli': 'napoli', 'napli': 'napoli', 'naopli': 'napoli',
    'giallorossi': 'roma', 'lupa': 'roma', 'as roma': 'roma', 'asroma': 'roma', 'rma': 'roma',
    'biancocelesti': 'lazio', 'aquilotti': 'lazio', 'ss lazio': 'lazio', 'laizo': 'lazio',
    'viola': 'fiorentina', 'gigliati': 'fiorentina', 'fiorntina': 'fiorentina',
    'orobici': 'atalanta', 'dea': 'atalanta', 'atalana': 'atalanta', 'atalanata': 'atalanta',
    'granata': 'torino', 'toro': 'torino', 'torino calcio': 'torino',
    'rossoblù': 'bologna', 'rossoblu': 'bologna', 'felsinei': 'bologna', 'bolgna': 'bologna',
    'rossoblù genoa': 'genoa', 'grifone': 'genoa', 'gnoa': 'genoa',
    'blucerchiati': 'sampdoria', 'samp': 'sampdoria', 'sampdria': 'sampdoria',
    'merengues': 'real-madrid', 'blancos': 'real-madrid', 'real': 'real-madrid', 'ral madrid': 'real-madrid', 'realmadrid': 'real-madrid',
    'blaugrana': 'barcellona', 'barça': 'barcellona', 'barca': 'barcellona', 'fcb': 'barcellona', 'barellona': 'barcellona',
    'colchoneros': 'atletico-madrid', 'atletico': 'atletico-madrid',
    'citizens': 'manchester-city', 'city': 'manchester-city', 'man city': 'manchester-city',
    'reds': 'liverpool', 'liverpol': 'liverpool', 'liverppol': 'liverpool',
    'blues': 'chelsea', 'chelsae': 'chelsea',
    'gunners': 'arsenal', 'arsnal': 'arsenal', 'arsenla': 'arsenal',
    'red devils': 'manchester-united', 'man utd': 'manchester-united', 'man united': 'manchester-united', 'united': 'manchester-united',
    'spurs': 'tottenham', 'totenham': 'tottenham', 'tothenham': 'tottenham',
    'fcb monaco': 'bayern-monaco', 'bayern': 'bayern-monaco', 'bayern munich': 'bayern-monaco',
    'bvb': 'borussia-dortmund', 'dortmund': 'borussia-dortmund',
    'psg': 'psg', 'paris': 'psg', 'paris saint germain': 'psg',
    'om': 'marsiglia', 'olympique': 'marsiglia',
    'azzurri': 'italia', 'nazionale': 'italia', 'itala': 'italia', 'italai': 'italia',
    'albiceleste': 'argentina', 'seleccion': 'argentina', 'argetina': 'argentina',
    'canarinha': 'brasile', 'selecao': 'brasile', 'brasle': 'brasile',
    'les bleus': 'francia', 'frncia': 'francia', 'fracnia': 'francia',
    'la roja': 'spagna', 'furia rossa': 'spagna', 'spagn': 'spagna',
    'die mannschaft': 'germania', 'germnaia': 'germania',
    'three lions': 'inghilterra', 'england': 'inghilterra', 'ingiltera': 'inghilterra',
    'seleccao': 'portogallo', 'portogllo': 'portogallo',
    'rode duivels': 'belgio', 'belgio': 'belgio',
    'vatreni': 'croazia', 'croaia': 'croazia',

    /* ── Color associations ── */
    'bianco nero': 'juventus', 'bianco e nero': 'juventus',
    'nero azzurro': 'inter', 'nero e azzurro': 'inter',
    'rosso nero': 'milan', 'rosso e nero': 'milan',
    'azzurro': 'napoli',
    'giallo rosso': 'roma', 'giallo e rosso': 'roma',
    'bianco celeste': 'lazio',
    'rosso blu': 'bologna',

    /* ── Concept-based ── */
    'regalo tifoso': null,      // Generic, will show trending
    'regalo interista': 'inter',
    'regalo milanista': 'milan',
    'regalo juventino': 'juventus',
    'regalo romanista': 'roma',
    'regalo laziale': 'lazio',
    'regalo napoletano': 'napoli',
    'cover calcio': null,
    'custodia calcio': null,
    'custodia squadra': null,
    'magsafe': null,
    'cover magsafe': null
  };

  /* ══════════════════════════════
     Levenshtein Distance (Fuzzy)
     ══════════════════════════════ */
  function levenshtein(a, b) {
    if (a.length === 0) return b.length;
    if (b.length === 0) return a.length;
    var matrix = [];
    for (var i = 0; i <= b.length; i++) matrix[i] = [i];
    for (var j = 0; j <= a.length; j++) matrix[0][j] = j;
    for (var i2 = 1; i2 <= b.length; i2++) {
      for (var j2 = 1; j2 <= a.length; j2++) {
        if (b.charAt(i2 - 1) === a.charAt(j2 - 1)) {
          matrix[i2][j2] = matrix[i2 - 1][j2 - 1];
        } else {
          matrix[i2][j2] = Math.min(
            matrix[i2 - 1][j2 - 1] + 1,
            matrix[i2][j2 - 1] + 1,
            matrix[i2 - 1][j2] + 1
          );
        }
      }
    }
    return matrix[b.length][a.length];
  }

  /* ══════════════════════════════
     Query Resolution
     ══════════════════════════════ */
  function resolveQuery(query) {
    var q = query.toLowerCase().trim();
    var result = {
      original: query,
      resolved: null,           // Collection handle or null
      suggestion: null,         // "Forse cercavi: X?"
      isFuzzy: false
    };

    // 1. Direct synonym match
    if (SYNONYMS[q] !== undefined) {
      result.resolved = SYNONYMS[q];
      return result;
    }

    // 2. Partial synonym match (query contains synonym key)
    for (var key in SYNONYMS) {
      if (q.indexOf(key) !== -1 && SYNONYMS[key] !== null) {
        result.resolved = SYNONYMS[key];
        return result;
      }
    }

    // 3. Fuzzy match — find closest synonym key
    var bestMatch = null;
    var bestDist = Infinity;
    var MAX_DIST = 2; // Max 2 character difference

    for (var sKey in SYNONYMS) {
      if (SYNONYMS[sKey] === null) continue;
      var dist = levenshtein(q, sKey);
      if (dist < bestDist && dist <= MAX_DIST) {
        bestDist = dist;
        bestMatch = sKey;
      }
    }

    // Also check against collection handles directly
    var allTeams = [];
    for (var sk in SYNONYMS) {
      if (SYNONYMS[sk] && allTeams.indexOf(SYNONYMS[sk]) === -1) {
        allTeams.push(SYNONYMS[sk]);
      }
    }
    for (var t = 0; t < allTeams.length; t++) {
      var teamName = allTeams[t].replace(/-/g, ' ');
      var dist2 = levenshtein(q, teamName);
      if (dist2 < bestDist && dist2 <= MAX_DIST) {
        bestDist = dist2;
        bestMatch = teamName;
        result.resolved = allTeams[t];
      }
    }

    if (bestMatch && bestDist > 0) {
      result.isFuzzy = true;
      result.suggestion = bestMatch.charAt(0).toUpperCase() + bestMatch.slice(1);
      if (!result.resolved) {
        result.resolved = SYNONYMS[bestMatch];
      }
    }

    return result;
  }

  /* ══════════════════════════════
     Trending Engine
     ══════════════════════════════ */
  function getTrending() {
    var now = new Date();
    var month = now.getMonth(); // 0-11
    var day = now.getDay();     // 0=Sun

    var trending = [];

    // Seasonal relevance
    if (month >= 7 && month <= 9) {
      // Aug-Oct: Season start
      trending.push(
        { label: '⚡ Nuova stagione 25/26', query: 'kit home serie a 25 26' },
        { label: '🔥 Kit Home Serie A', query: 'serie a home' }
      );
    } else if (month >= 3 && month <= 5) {
      // Apr-Jun: Season finale
      trending.push(
        { label: '🏆 Finale di stagione', query: 'champions' },
        { label: '⚡ Cover Nazionali', query: 'nazionali' }
      );
    }

    // Always trending
    trending.push(
      { label: '🇮🇹 Serie A', query: 'serie a' },
      { label: '⭐ Juventus', query: 'juventus' },
      { label: '🔴⚫ Milan', query: 'milan' },
      { label: '⚫🔵 Inter', query: 'inter' },
      { label: '🔵 Napoli', query: 'napoli' }
    );

    // Weekend: match day hype
    if (day === 6 || day === 0) {
      trending.unshift({ label: '⚽ Matchday!', query: 'serie a' });
    }

    // Personalized from AI profile
    if (window.EliseeAI) {
      var affinity = window.EliseeAI.getAffinity();
      if (affinity.length > 0) {
        var topTeam = affinity[0].team;
        var teamLabel = topTeam.charAt(0).toUpperCase() + topTeam.slice(1).replace(/-/g, ' ');
        trending.unshift({
          label: '🧠 ' + teamLabel + ' per te',
          query: topTeam
        });
      }
    }

    // Limit to 6
    return trending.slice(0, 6);
  }

  /* ══════════════════════════════
     Hook into Predictive Search
     ══════════════════════════════ */
  function enhanceSearch() {
    // Find the search input
    var searchInputs = document.querySelectorAll('input[type="search"], input[name="q"], .search__input');
    if (searchInputs.length === 0) return;

    searchInputs.forEach(function(input) {
      // Add trending suggestions on focus
      input.addEventListener('focus', function() {
        showTrendingSuggestions(input);
      });

      // Intercept search to apply smart resolution
      var form = input.closest('form');
      if (form) {
        form.addEventListener('submit', function(e) {
          var query = input.value.trim();
          if (!query) return;

          var resolved = resolveQuery(query);
          if (resolved.resolved) {
            e.preventDefault();
            window.location.href = '/collections/' + resolved.resolved;
          }
        });
      }

      // Real-time suggestion as user types
      var debounceTimer;
      input.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          var query = input.value.trim();
          if (query.length < 2) {
            removeFuzzyBanner();
            return;
          }
          var resolved = resolveQuery(query);
          if (resolved.isFuzzy && resolved.suggestion) {
            showFuzzyBanner(input, resolved);
          } else {
            removeFuzzyBanner();
          }
        }, 300);
      });
    });
  }

  /* ══════════════════════════════
     UI: Trending Suggestions
     ══════════════════════════════ */

  function showTrendingSuggestions(input) {
    // Don't show if already has content
    if (input.value.trim().length > 0) return;

    var modal = input.closest('.elisee-search-modal');
    if (!modal) return;

    // Check if we already added trending in this modal
    var existing = modal.querySelector('.elisee-smart-trending-wrap');
    if (existing) {
      existing.style.display = 'flex';
      return;
    }

    var trending = getTrending();
    var container = document.createElement('div');
    container.className = 'elisee-smart-trending-wrap';
    container.setAttribute('role', 'listbox');

    var title = document.createElement('div');
    title.className = 'elisee-smart-trending-title';
    title.textContent = 'Ricerche di tendenza';
    container.appendChild(title);

    trending.forEach(function(item) {
      var tag = document.createElement('button');
      tag.type = 'button';
      tag.className = 'elisee-smart-trending-tag';
      tag.setAttribute('role', 'option');
      tag.textContent = item.label;
      tag.addEventListener('click', function() {
        input.value = item.query;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        // Trigger search
        var form = input.closest('form');
        if (form) {
          var resolved = resolveQuery(item.query);
          if (resolved.resolved) {
            window.location.href = '/collections/' + resolved.resolved;
          } else {
            form.submit();
          }
        }
      });
      container.appendChild(tag);
    });

    modal.appendChild(container);

    // Hide trending when user starts typing
    input.addEventListener('input', function hideTrending() {
      if (input.value.trim().length > 0) {
        container.style.display = 'none';
      } else {
        container.style.display = 'flex';
      }
    });
  }

  /* ══════════════════════════════
     UI: "Forse cercavi..." Banner
     ══════════════════════════════ */
  function showFuzzyBanner(input, resolved) {
    removeFuzzyBanner();

    var banner = document.createElement('div');
    banner.id = 'elisee-fuzzy-banner';
    banner.className = 'elisee-fuzzy-banner-wrap';
    banner.innerHTML = '<span style="font-size:1.3rem;">🔍</span>' +
      '<span style="font-size:1.2rem;color:#c9a8f0;">Forse cercavi: <strong style="color:#00d2ff;">' + resolved.suggestion + '</strong>?</span>';

    banner.addEventListener('click', function() {
      if (resolved.resolved) {
        window.location.href = '/collections/' + resolved.resolved;
      } else {
        input.value = resolved.suggestion;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });

    // Insert correctly: append to .elisee-search-modal if present, otherwise fallback
    var modal = input.closest('.elisee-search-modal');
    if (modal) {
      modal.appendChild(banner);
    } else {
      var parent = input.closest('.predictive-search') ||
                   input.closest('.search-modal__content') ||
                   input.closest('form');
      if (parent) {
        var resultsArea = parent.querySelector('.predictive-search__results, predictive-search');
        if (resultsArea) {
          resultsArea.parentNode.insertBefore(banner, resultsArea);
        } else {
          parent.appendChild(banner);
        }
      }
    }
  }

  function removeFuzzyBanner() {
    var existing = document.getElementById('elisee-fuzzy-banner');
    if (existing) existing.remove();
  }

  /* ══════════════════════════════
     Public API
     ══════════════════════════════ */
  window.EliseeSmartSearch = {
    resolve: resolveQuery,
    getTrending: getTrending
  };

  /* ══════════════════════════════
     Initialize
     ══════════════════════════════ */
  function init() {
    enhanceSearch();

    // Also re-init when search modal opens (Dawn uses dynamic rendering)
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          var hasSearch = false;
          mutations[i].addedNodes.forEach(function(node) {
            if (node.querySelector && node.querySelector('input[type="search"], input[name="q"]')) {
              hasSearch = true;
            }
          });
          if (hasSearch) {
            setTimeout(enhanceSearch, 100);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
